import SemrLink from '@semcore/ui/link';

export const Link = SemrLink;
